import * as React from 'react';
import { getId } from 'office-ui-fabric-react/lib/Utilities';
import { ServiceRequest } from "../../Utils/ServiceRequest";
import {MIPALinksobj} from '../../Entity/Linkobj';
import {
  getTheme,
  mergeStyleSets,
  FontWeights,
  //ContextualMenu,
  //Checkbox,
  //DefaultButton,
  Modal,
  //DragOptions,
  IconButton
} from 'office-ui-fabric-react';


import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { FontSizes } from '@uifabric/styling';

export interface IProps {
    closeMethod;
    Link:MIPALinksobj;
    UpdateLink
  }

const theme = getTheme();
const contentStyles = mergeStyleSets({
  container: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'stretch'
  },
  header: [
    // tslint:disable-next-line:deprecation
    theme.fonts['xLargePlus'],
    {
      flex: '1 1 auto',
      borderTop: `4px solid ${theme.palette.themePrimary}`,
      color: theme.palette.neutralPrimary,
      display: 'flex',
      fontSize: FontSizes.xLarge,
      alignItems: 'center',
      fontWeight: FontWeights.semibold,
      padding: '12px 12px 14px 24px'
    }
  ],
  body: {
    flex: '4 4 auto',
    padding: '0 24px 24px 24px',
    overflowY: 'hidden',
    selectors: {
      p: {
        margin: '14px 0'
      },
      'p:first-child': {
        marginTop: 0
      },
      'p:last-child': {
        marginBottom: 0
      }
    }
  }
});

const iconButtonStyles = mergeStyleSets({
  root: {
    color: theme.palette.neutralPrimary,
    marginLeft: 'auto',
    marginTop: '4px',
    marginRight: '2px'
  },
  rootHovered: {
    color: theme.palette.neutralDark
  }
});
export default class NewLink extends React.Component<IProps> {  
   /*  private _titleId: string = getId('title');
    private _subtitleId: string = getId('subText');
    private _dragOptions: IDragOptions = {
                                            moveMenuItemText: 'Move',
                                            closeMenuItemText: 'Close',
                                            menu: ContextualMenu
                                        }; */
   
    private FromValidationMessages=[];
    public SRequest = new ServiceRequest();
    public state={
      isLoading:false
    };
        public ListFields=[];
       public choicevalue=[];     
  
    public linkDataitem:MIPALinksobj;
    constructor(props) {
        super(props);    
        this.linkDataitem=this.props.Link;
         
        }
    public ChangeState(){
        this.setState({changed:new Date()});
    }
    public render() {
           
    return (
            <div>         
              <Modal
                titleAriaId={getId('title')}
                subtitleAriaId={getId('subtitle')}
                isOpen={true}
                onDismiss={()=>{
                    this.props.closeMethod();
                    //setShowEntryForm(false);
                }}
                isBlocking={true}
                containerClassName={contentStyles.container}
                //dragOptions={this._dragOptions}
              >
              <div className={contentStyles.header}>
              <span id={getId('title')}>Link</span>
             
              <IconButton
                styles={iconButtonStyles}
                iconProps={{ iconName: 'Cancel' }}
                ariaLabel="Close popup modal"
                onClick={()=>{this.props.closeMethod();}}
              />
              </div>
              
              <div id={getId('Subtitle')} className={contentStyles.body} style={{overflow:'auto'}}>
              <div className="ms-Grid-row">    
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6">
                    <TextField 
                        onChange={(event)=>{                           
                            this.linkDataitem.DisplayName=event.target["value"];
                          this.ChangeState();  
                        }}
                        value={this.linkDataitem.DisplayName}
                        label="Display text"
                        placeholder="Display text" />                        
                  </div>              
                  <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6">
                    <TextField
                    type="url" 
                        onChange={(event)=>{
                            this.linkDataitem.URL=event.target["value"];
                            this.ChangeState(); 
                        }}  
                        value={this.linkDataitem.URL}
                        label="Site URL"
                        placeholder="Site URL"
                    />                        
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6">
                    <TextField 
                    multiline={true}
                    rows={3}
                        onChange={(event)=>{
                            this.linkDataitem.Description=event.target["value"];
                            this.ChangeState(); 
                        }}  
                        value={this.linkDataitem.Description}
                        label="Description"
                        placeholder="Description" />                        
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6">
                    <TextField 
                    type="number"
                        onChange={(event)=>{
                            this.linkDataitem.Priority=event.target["value"];
                            this.ChangeState(); 
                        }}  
                        value={this.linkDataitem.Priority.toString()}
                        label="Priority"
                        placeholder="Priority" />                        
                  </div>
                  
              </div>
              
              
              {/* <div className="ms-Grid-row">
                 <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 notebox">
                   <ul className="error">
                     {this.FromValidationMessages}
                   </ul>
                   
                 </div>
              </div> */}
              <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                      <div className="buttonarea">
                      <button onClick={this.SaveLinfo} className="ms-Button ms-Button--default viewswitchbtn plannertask">
                        Save
                      </button>
                      <button 
                        className="ms-Button ms-Button--default viewswitchbtn"
                        onClick={()=>{this.props.closeMethod()}}
                      >
                        Cancel
                      </button>
                      </div>
                    
                  </div>
              </div>
              </div>
              </Modal>
            </div>
            );
  }
  
  
  private SaveLinfo=()=>{
    this.FromValidationMessages=[];
    if(this.linkDataitem.DisplayName=='' || this.linkDataitem.DisplayName==null){
      this.FromValidationMessages.push(<li>Please provide display text</li>);
    }
    if(this.linkDataitem.URL=='' || this.linkDataitem.URL==null){
      this.FromValidationMessages.push(<li>Please provide valid url</li>);
    }
    

    if(this.FromValidationMessages.length>0){
      this.setState({changeed:true});
      return;
    }
    this.props.UpdateLink(this.linkDataitem);
    
  }
  
}
